<template>
  <div class="bill-statistic-wrapper custom-wrapper">
    <div class="statistic-container income">
      <h3>总收益</h3>
      <el-tooltip placement="top">
        <div slot="content">
          <span>交易笔数：{{ incomeCount }}</span>
        </div>
        <p>{{ (income / 100).toFixed(2) }}</p>
      </el-tooltip>
    </div>
    <div class="statistic-container refund">
      <h3>总退款额</h3>
      <el-tooltip placement="top">
        <div slot="content">
          <span>退款笔数：{{ refundCount }}</span>
        </div>
        <p>{{ (refund / 100).toFixed(2) }}</p>
      </el-tooltip>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'BillStatistic',
  computed: {
    ...mapState('bill', [
      'orderCount',
      'incomeCount',
      'refundCount',
      'income',
      'refund'
    ]),
    ...mapGetters('bill', [
      'incomeSum',
      'refundSum'
    ])
  }
}
</script>

<style lang="scss" scoped>
.bill-statistic-wrapper {
  display: flex;
  justify-content: space-around;
  align-items: center;

  .statistic-container {
    text-align: center;

    h3 {
      margin: .6rem 0;
    }
    p {
      font-size: 1.4rem;
      margin: .6rem 0;
    }

    &.income {
      color: #4ab861;
    }
    &.refund {
      color: #918c87;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bill/BillStatistic.vue